import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchDashboardComponent } from './switch-dashboard.component';
import { AngularMaterialModule } from '@shared/angular-material/angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
    declarations: [SwitchDashboardComponent],
    imports: [CommonModule, AngularMaterialModule, FlexLayoutModule],
    exports: [SwitchDashboardComponent]
})
export class SwitchDashboardModule { }
